import Vue from 'vue';
import { format, parseISO } from 'date-fns';
import XRegExp from 'xregexp';

export const DATE_FORMAT = 'yyyy-MM-dd';
export const DATE_TIME_FORMAT = 'yyyy-MM-dd HH:mm';

export const DATE_TIME_LONG_FORMAT = "yyyy-MM-dd'T'HH:mm";
export const INSTANT_FORMAT = "yyyy-MM-dd'T'HH:mm:ssZ";
export const ZONED_DATE_TIME_FORMAT = "yyyy-MM-dd'T'HH:mm:ssXXXXX";

export function initFilters() {
  Vue.filter('formatDate', function(value) {
    const DATE_STRING_REGEX = XRegExp('^(\\d{4}-\\d{2}-\\d{2})([T\\s])?(\\d{2}:\\d{2}:\\d{2}(\\.\\d{3})?)?(Z)?$');

    if (DATE_STRING_REGEX.test(value)) {
      return format(parseISO(value), DATE_TIME_FORMAT);
    }
    return '';
  });
  Vue.filter('formatMillis', function(value, pattern: string = DATE_TIME_FORMAT) {
    if (value) {
      return format(new Date(value), pattern);
    }
    return '';
  });
}
